import { clsx } from 'clsx';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import { Link } from 'react-scroll';
import { EDescriptionType, TFirstBlockContentValue } from 'shared/containers/PagesContainer/types';

export const FirstBlock: React.FC<TFirstBlockContentValue> = ({ title, description, needBigFont, imageClass }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['textblock']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['description-block']}>
            {description.map((item, key) => (
              <div className={clsx(styles['description'], needBigFont && styles['big'])} key={key}>
                {item.map((str, key) => {
                  if (str.type === EDescriptionType.AnchorLink) {
                    return (
                      <Link className={styles['link']} smooth key={key} to={str.url}>
                        {str.text}
                      </Link>
                    );
                  }
                  if (str.type === EDescriptionType.Link) {
                    return (
                      <a className={styles['link']} key={key} href={str.url} target="_blank" rel="noreferrer">
                        {str.text}
                      </a>
                    );
                  }

                  return str.text;
                })}
              </div>
            ))}
          </div>
        </div>
        <div className={clsx(styles['image'], styles[imageClass])} />
      </div>
    </div>
  );
};
